import { Typography, TypographyProps } from '@mui/material';

export const PageTitle = (props: TypographyProps) => {
    return (
        <Typography
            variant='h1'
            fontSize={24}
            lineHeight={1.3333}
            fontWeight={'normal'}
            {...props}
        />
    );
};

export const PageSubtitle = (props: TypographyProps) => {
    return (
        <Typography variant='h4' fontSize={20} lineHeight={1.27} fontWeight={'normal'} {...props} />
    );
};
